<div
  class="sp-width__full sp-height__full sp-page__with-navbar"
  [ngClass]="getNavbarClass()">
  <app-navbar
    class="sp-hidden__before-lg"
    [current_nav_item]="current_nav_item"
    [navbar_status]="navbar_status"
    (status_change)="onNavbarStatusChange($event)"></app-navbar>

  <div class="sp-position__relative">
    <app-toolbar
      [current_nav_item]="current_nav_item"
      [width_class]="getToolbarWidthClass()"></app-toolbar>

    <div class="sp-page__with-absolute-toolbar sp-grid__gap sp-padding__x2 sp-order-details__grid">
      <app-order-details-header
        [order_id]="order_id"
        [store_id]="store_id"
        (tab_change)="onTabChange($event)"
        (refresh)="onRefresh()"></app-order-details-header>

      <app-order-details-general
        *ngIf="current_tab === tabs.get('article')"
        [order_id]="order_id"
        [store_id]="store_id"></app-order-details-general>

      <app-order-details-installments
        *ngIf="current_tab === tabs.get('list')"
        [order_id]="order_id"
        [store_id]="store_id"></app-order-details-installments>

      <app-order-details-decido
        *ngIf="current_tab === tabs.get('arrow_split')"
        [order_id]="order_id"
        [store_id]="store_id"></app-order-details-decido>

      <app-order-details-qinetic
        *ngIf="current_tab === tabs.get('computer')"
        [order_id]="order_id"
        [store_id]="store_id"></app-order-details-qinetic>

      <app-order-details-events *ngIf="current_tab === tabs.get('timeline')"></app-order-details-events>
    </div>
  </div>
</div>
